import { render, staticRenderFns } from "./pin.vue?vue&type=template&id=f62b4d18&scoped=true"
import script from "./pin.vue?vue&type=script&lang=js"
export * from "./pin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62b4d18",
  null
  
)

export default component.exports